import { Alert } from '../Alert';

export interface AlertErrorProps {
  children?: any;
}

/**
 * @deprecated Use `<Alert tone="error">`. Kept so the existing call sites keep
 * working; it is now a thin wrapper and renders identically apart from the
 * leading icon Alert adds.
 */
export const AlertError = ({ children }: AlertErrorProps) => <Alert tone='error'>{children}</Alert>;
